interface Props {
  icon: React.ReactNode;
  label: string;
  count: number;
  amount: number;
  variant: 'green' | 'dark';
  showAmount?: boolean;
  isActive?: boolean;
  onClick?: () => void;
}

const TaskStatBox: React.FC<Props> = ({ icon, label, count, amount, variant, showAmount = true, isActive, onClick }) => {
  const badgeColor = variant === 'green'
    ? 'border-green-500 text-green-600'
    : 'border-gray-500 text-gray-600';
  const numColor = variant === 'green' ? 'text-green-500' : 'text-blue-900';

  const activeRing = isActive
    ? variant === 'green'
      ? 'bg-green-50 ring-2 ring-green-400 ring-inset rounded-xl'
      : 'bg-gray-50 ring-2 ring-gray-400 ring-inset rounded-xl'
    : '';

  return (
    <div
      onClick={onClick}
      className={`flex-1 flex flex-col gap-1.5 px-6 py-3 border-r border-gray-200 last:border-r-0 transition-all
        ${onClick ? 'cursor-pointer hover:bg-gray-50' : ''}
        ${activeRing}
      `}
    >
      <span className={`flex items-center gap-1.5 border rounded-full px-3 py-1 text-base font-semibold w-fit ${badgeColor}`}>
        {icon}
        {label}
        <span className="font-extrabold ml-0.5">{count}</span>
      </span>
      {showAmount && (
        <span className={`text-3xl font-extrabold tracking-tight ${numColor}`}>
          ₹{amount.toLocaleString('en-IN')}
        </span>
      )}
    </div>
  );
};

export default TaskStatBox;
